<template>
  <div>
    <validationObserver v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(submitForm)">
        <b-row>

          <!-- Discount -->
          <b-col md="12">
            <input-form
                v-model="coupon.discount"
                placeholder="Enter Discount"
                validate="required|numeric|between:0,100"
                name="discount"
                label="Discount"
            />
          </b-col>

          <!-- Applies On -->
          <b-col md="12">

            <span class="d-flex gap-1 mb-2">
              Applies On

              <b-form-radio
                  name="appliesOn"
                  value="tickets"
                  v-model="coupon.appliesOn"
              >
                All Tickets
              </b-form-radio>

              <b-form-radio
                  name="appliesOn"
                  value="promotions"
                  v-model="coupon.appliesOn"
              >
                All Promotions
              </b-form-radio>

              <b-form-radio
                  name="appliesOn"
                  value="purchases"
                  v-model="coupon.appliesOn"
              >
                All Purchases
              </b-form-radio>

            </span>

            <main-select
                v-if="!coupon.appliesOn"
                v-model="coupon.appliesOnGroup"
                :options="appliesOnOptions"
                multiple
                label="key"
                placeholder="--Select--"
            />

          </b-col>

          <!-- Validity -->
          <b-col md="12">
            <validation-provider
                #default="{ errors }"
                name="Validity"
                :rules="{ required: !coupon.unlimited }"
            >

              <b-form-group>

                <label class="d-flex justify-content-between">
                  <span>Validity</span>

                  <input-switch
                      id="unlimited"
                      name="unlimited"
                      label="Unlimited"
                      v-model="coupon.unlimited"
                  />

                </label>

                <b-input-group append="Day(s)">

                  <b-form-input
                      :disabled="coupon.unlimited"
                      v-model="coupon.validity_days"
                      placeholder="Enter days"
                      :class="[{ 'is-invalid': errors.length > 0 }]"
                  />

                </b-input-group>

                <small class="text-danger">{{ errors[0] }}</small>

              </b-form-group>

            </validation-provider>
          </b-col>

        </b-row>

        <!-- Submit -->
        <b-row>
          <b-col md="12" class="mt-4">
            <div class="d-flex justify-content-center">
              <b-button :class="`button-${typeOfModal == 'add' ? 'orange' : 'blue'}-modal`" type="submit">
                <i v-if="!requestLoading" :class="`las la-${typeOfModal == 'add' ? 'plus' : 'pen'}`"></i>
                <spinner-loading v-else></spinner-loading>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </b-form>
    </validationObserver>
  </div>
</template>

<script>
import promotionsServices from '../services/promotions.services'
import ticketsServices from '../services/tickets.services'

export default {

  props: {
    requestLoading: {
      type: Boolean,
      default: false
    },
    typeOfModal: { type: String, default: 'add' },
    details: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {

      coupon: {
        unlimited: false,
        validity_days: '',
        purchase: '',
        appliesOn: '',
        appliesOnGroup: [],
        discount: ''
      },

      allTickets: [],
      allPurchases: [],
      allPromotions: []

    }
  },

  watch: {

    'coupon.appliesOn' (newValue) {

      if (newValue === 'purchases') {
        this.coupon.appliesOnGroup = []
      }

      if (newValue === 'promotions') {
        this.coupon.appliesOnGroup =
            this.coupon.appliesOnGroup.filter(item => item.type !== 'promotions')
      }

      if (newValue === 'tickets') {
        this.coupon.appliesOnGroup =
            this.coupon.appliesOnGroup.filter(item => item.type !== 'tickets')
      }

    }

  },

  methods: {

    submitForm () {

      const payload = {
        ...this.coupon,
        unlimited: +this.coupon.unlimited
      }

      this.$emit('submitForm', payload)

    }

  },

  computed: {

    appliesOnOptions () {

      const { appliesOn } = this.coupon

      if (appliesOn === 'tickets') {
        return [...this.allPromotions, ...this.allPurchases]
      }

      if (appliesOn === 'promotions') {
        return [...this.allTickets, ...this.allPurchases]
      }

      if (appliesOn === 'purchases') {
        return [...this.allTickets, ...this.allPromotions]
      }

      return [
        ...this.allTickets,
        ...this.allPromotions,
        ...this.allPurchases
      ]

    }

  },

  created () {

    ticketsServices.getAllTicketsLimit().then((response) => {

      this.allTickets = response.data.data.data.map(ticket => ({
        value: ticket.id,
        key: ticket.name,
        type: 'tickets'
      }))

    })

    promotionsServices.getAllPromotions().then((response) => {

      this.allPromotions = response.data.data.current.data
          .filter(promotion => promotion.type !== 'discount')
          .map(promotion => ({
            value: promotion.id,
            key: promotion.name,
            type: 'promotions'
          }))
    })

    if (this.details) {

      this.coupon.discount = this.details.discount_ratio
      this.coupon.appliesOn = this.details.applies_on
      this.coupon.validity_days = this.details.validity_days

      this.coupon.unlimited = Boolean(this.details.unlimited)
      this.coupon.appliesOnGroup = [
        ...this.details.tickets.map(ticket => ({
          value: ticket.id,
          key: ticket.name,
          type: 'tickets'
        })),

        ...this.details.promotions.map(promotion => ({
          value: promotion.id,
          key: promotion.name,
          type: 'promotions'
        }))
      ]
    }

  }

}
</script>

<style scoped>
</style>